<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="card">
        <div class="card-header"> {{ t.navigation.users }}
          <a class="tag tag-danger update-all-card text-white" href="javascript:;" @click="fetchCustomers()">{{ t.custom_reseller_panel.update_user_cards}}</a>
        </div> <!-- tr -->
        <div class="card-block p-0">
          <div class="easy-autocomplete">
            <CustomerSearch usageArea="customer"></CustomerSearch>
          </div>
          <input type="hidden" id="redirect">
          <div class="table-responsive">
            <table class="table table-striped mb-0">
              <thead>
              <tr>
                <th style="width: 20%">{{ t['transaction'] }}</th>
                <th style="width: 30%">Card</th> <!-- tr -->
                <th style="width: 15%">{{ t.balance.title }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-if="loading">
                <td colspan="4" align="center">
                  <Loading></Loading>
                </td>
              </tr>
              <template v-if="!loading">
                <tr v-if="customers.length < 1">
                  <td colspan="4" align="center">{{ t.error.notfound_content_list }}</td>
                </tr>
                <tr v-for="(customer, idx) in customers" :key="idx">
                  <td>
                    <div class="mobilflex">
                      <router-link :to="{name: 'CustomerDetail', params: {id: customer.id}, query: {referrer: customer.referrer}}" tag="a" class="btn btn-info m-0 text-white">
                        <i class="fa fa-eye"></i>
                      </router-link>
                      <a class="btn btn-success m-0 customer-payin text-white" @click="openPayinModal(customer.id, '+')">
                       {{ t.custom_reseller_panel.balance_in }} 
                      </a>
                      <a class="btn btn-danger m-0 customer-payout text-white" @click="openPayinModal(customer.id, '-')">
                        {{ t.custom_reseller_panel.balance_out }}
                      </a>
                    </div>
                  </td>
                  <td>
                    <router-link :to="{name: 'CardBayi', query: {uid: customer.id, page: 1}}" tag="a" class="btn btn-primary btn-xs btn-durum">
                      {{ customer.username }}
                    </router-link>
                    <router-link :to="{name: 'CardBayi', query: {uid: customer.id, page: 1}}" tag="a" class="btn btn-success btn-xs btn-durum">
                      {{ customer.fullName }}
                    </router-link>
                  </td>
                  <td>
                    <code>{{ customer.balance }}</code>
                  </td>
                </tr>

              </template>
              </tbody>
            </table>
            <div class="fixed-table-footer">
              <paginate v-if="pagination" class="mx-3"
                        :page-count="pagination.pageCount"
                        :page-range="pagination.pageRange"
                        :force-page="pagination.current"
                        :initialPage="pagination.current"
                        :margin-pages="$root.windowWidth < 600 ? 0 : 2"
                        :click-handler="onChangePage"
                        :prev-text="t.previous"
                        :next-text="t.next"
                        :container-class="'my-1 pagination float-right mr-0 ml-1'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-class="'page-item'"
                        :next-link-class="'page-link'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import CustomerSearch from "../CustomerSearch";
import Loading from "../Loading";
export default {
  name: "CustomerList",
  components: {Loading, CustomerSearch, Paginate},
  data() {
    return {
      customers: [],
      session: session,
      pagination: null,
      t: this.$root.t,
      loading: false
    }
  },
  mounted() {
    this.$router.push({query: {page: 1, referer: this.$route.query.referer}});
    this.fetchCustomers();
  },
  methods: {
    fetchCustomers() {
      this.loading = true;
          this.$http.get(api + 'api/v1/users', {
            params: {
              page: this.$route.query.page,
              per_page: 10,
              direction: 'desc',
              referrer: this.$route.query.referer,
              group: [5],
              sort: 'u.balance'
            }
          })
          .then(response => {
            this.customers = response.body.result.users;
            this.pagination = null;
            this.pagination = response.body.result.pagination;
            this.total = response.body.result.total
            this.loading = false;
            this.notfound = false;
          }, response => {
            this.customers = [];
            this.loading = false;
            this.notfound = true;
          })
    },
    onChangePage(page) {
      this.pagination.current = page;
      this.$router.push({query: {page: page}});
      window.scroll(0, 0);
      this.fetchCustomers()
    },
    openPayinModal(user, operate) {
      this.$bus.$emit('payinModal', {id: user, action: true, operate: operate})
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 500px){

  .mobilflex {
    width: 150px;
  }
  .btn {
      font-size: 0.700rem;
      padding: 0.5rem 0.7rem;
  }
  .table td {
    padding: 10px 1px;
  }

  .btn-durum {
    display: block;
    text-align: left;
    padding: 0.2rem 0.2rem;
    margin: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/CustomerList.vue